$(document).ready(function(){
$(document).on("click", ".video-with-svg", function () {
  var $video = $(this).find("video");
    
    if ($video[0].paused) {
        $video.trigger("play");
          
    } else {
      
        $video.trigger("pause");
      
    }
});
$(".video-with-svg video").on("pause", function () {
    $(this).parent().find("svg").show();
   // $(this).removeAttr("controls");
  });
  $(".video-with-svg video").on("playing", function () {
    $(this).parent().find("svg").hide();
    // $(this).attr("controls","controls");
  });

  
    $("cart-drawer").load(location.href + " cart-drawer>*","");
  $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");

if ($(window).width() < 1025){
  $(".navigation-link.menu-with-dropdown").addClass("menu-activated-class");
    }
    

  // $(".all-products-cus").slick({
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   dots: false,
  //   infinite: false,
  //   responsive: [
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 2,
          
  //         dots: true,
  //       }
  //     },
  //     {
  //       breakpoint: 577,
  //       settings: {
  //         slidesToShow: 1,
          
  //         dots: true,
  //       }
  //     }
  //   ]
  // });
  $(".slider-video-section").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          
          dots: true,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          
          dots: true,
        }
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 1.5,
          
          dots: true,
        }
      }
    ]
  });
  $(".slider-video-section").on("afterChange",function (event, slick, currentSlide, nextSlide) {
      $(".slider-video-section video").trigger("pause");
  });
 $(document).on("click", ".single-video-slider video", function() {
    var $video = $(this); // Reference to the clicked video

    // Pause all other videos in the slider
    $(".single-video-slider video").not($video).each(function() {
        this.pause();
    });

    // Toggle the play/pause state of the clicked video
    if ($video[0].paused) {
        $video[0].play();
    } else {
        $video[0].pause();
    }
});
$(".single-video-slider video").on("pause", function () {
    $(this).parent().find("svg").show();
  });
  $(".single-video-slider video").on("playing", function () {
    $(this).parent().find("svg").hide();
  });
  
   $(document).on("click", ".faq-que", function() {
     $(this).parents(".shopify-section").find(".main-faq-single").not($(this).parents(".main-faq-single")).removeClass("active-faq");  
    // $(".main-faq-single").not($(this).parents(".main-faq-single")).removeClass("active-faq");
      $(this).parents(".main-faq-single").toggleClass("active-faq");
    // $(".faq-ans").not($(this).next(".faq-ans")).slideUp(); 
     $(this).parents(".shopify-section").find(".faq-ans").not($(this).next(".faq-ans")).slideUp(300);
    $(this).next(".faq-ans").slideToggle(); 
  });
$(document).on("click", ".add-to-cart-link", function(event) {
  
   event.preventDefault();
  var url = $(this).attr("href");

var parts = url.split('/'); // Split by '/'
var number = parts[parts.length - 1].split(':')[0]; // Split the last part by ':'

$.ajax({
      url: "/cart/add.js",
      type: "post",
       dataType:'json',
          async: false,
       data:  { quantity: 1, id:number },           
      success: function(cart){
        $("cart-drawer").removeClass("is-empty")
            $("cart-drawer").load(location.href + " cart-drawer>*","");
  $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");
        $("#cart-icon-bubble")[0].click();
     },
      error: function(err){     
      }
      }); 
});

// 31/03

  $(".after--before_slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          dots: true,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          dots: true,
        }
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 1,
          centerMode:true,
          infinite: true,
          centerPadding: '25px',
          dots: true,
        }
      }
    ]
  });
  
  
  })